//宣传页
import DoorTip from "@/views/ad/DoorTip";
import DoorGuard from "@/views/ad/DoorGuard";
import LightID from "@/views/ad/LightID";
import NBLock from "@/views/ad/NBLock";
import InternetConference from "@/views/ad/InternetConference";


//协议
const IDTip = () => import("@/views/ad/IDTip");
const PayTip = () => import("@/views/ad/PayTip");
// const ConcealTip = () => import("@/views/ad/ConcealTip");
const Privacy = () => import("@/views/agreement/Privacy");
const ShortCut = () => import("@/views/ad/ShortCut");
const Cuide = () => import("@/views/ad/Guide")

//跳转
const Jump = () => import("@/views/ad/Jump");

const routes = [
    {
        path: "/InternetConference",
        name: "InternetConference",
        meta: {
            title: "互联网大会"
        },
        component: InternetConference
    },
    {
        path: "/DoorTip",
        name: "DoorTip",
        meta: {
            title: "门锁推广"
        },
        component: DoorTip
    },
    {
        path: "/DoorGuard",
        name: "DoorGuard",
        meta: {
            title: "闪易光门禁"
        },
        component: DoorGuard
    },
    {
        path: "/LightID",
        name: "LightID",
        meta: {
            title: "闪易光ID"
        },
        component: LightID
    },
    {
        path: "/NBLock",
        name: "NBLock",
        meta: {
            title: "NB门锁"
        },
        component: NBLock
    },

    {
        path: "/IDTip",
        name: "IDTip",
        meta: {
            title: "闪易光ID协议"
        },
        component: IDTip
    },
    {
        path: "/PayTip",
        name: "PayTip",
        meta: {
            title: "免密支付说明"
        },
        component: PayTip
    },
    {
        path: "/ConcealTip",
        name: "ConcealTip",
        meta: {
            title: "titles.privacyPolicy"
        },
        component: Privacy
    },
    {
        path: "/concealTipNew",
        name: "ConcealTipNew",
        meta: {
            title: "titles.shortCut"
        },
        component: Privacy
    },
    {
        path: "/jump",
        name: "Jump",
        meta: {
            title: "跳转"
        },
        component: Jump
    },
    {
        path: "/shortCut",
        name: "ShortCut",
        meta: {
            title: "titles.shortCut"
        },
        component: ShortCut
    },
    {
        path: "/Y",
        name: "Guide",
        meta: {
            title: "闪光吉祥物使用场景"
        },
        component: Cuide
    },
];
export default routes;
